import { memo } from 'react';
import type { ReactNode } from 'react';
import { Checkbox } from '@library';
import styles from './Filter.module.scss';

const FilterCheckbox = ({
    updateCurrentValues,
    selectedValues,
    value,
    children,
    ...ariaProps
}: {
    updateCurrentValues(
        value: string,
        isRemove?: boolean,
        isReplace?: boolean
    ): void;
    selectedValues: string[];
    value: string;
    children: ReactNode;
}) => {
    return (
        <div className={styles.checkbox} {...ariaProps} title={value}>
            <Checkbox
                value={value}
                checked={selectedValues.includes(value)}
                onChange={e => {
                    updateCurrentValues(value, !e);
                }}
                truncate
            >
                <div className={styles.checkboxLabel}>{children}</div>
            </Checkbox>
        </div>
    );
};

export default memo(FilterCheckbox);
